import {ReactNode} from 'react';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {useAuth} from "../hooks/useAuth.ts";
import {
    PageNotFound,
    PlatformLoader
} from "@flexinet/ui-components";


export const RestrictedRouteElement = (
    {
        rbacAction,
        children,
    }: {
        rbacAction: string
        children: ReactNode,
    }
) => {
    const {user} = useAuth();
    const {
        authorizing,
        allowedActions
    } = useVerifiedPermissions()

    if (!user) {
        return <PageNotFound message={'Forbidden'}/>
    }

    if (typeof allowedActions == 'undefined' || allowedActions === null || allowedActions.length === 0) {
        if (authorizing) {
            return <PlatformLoader message={'Loading resources...Please, wait!'}/>
        } else {
            return <PageNotFound message={'Forbidden'}/>
        }
    }


    if (allowedActions.includes(rbacAction)) {
        return children
    } else {
        return <PageNotFound message={'Forbidden'}/>
    }


}
